module.exports = "/virtual-football-league/img/amblems/left/logos/Osa.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Osa.png
// module id = 2115
// module chunks = 4